module.exports = __webpack_public_path__ + "img/somos-cohen-y-aguirre.a7c70448.png";